'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
const StyledListItem = styled('li')(`
    padding: 0;
    background-color: unset;
    text-decoration: unset;
    outline: unset;

    box-sizing: border-box;
    list-style: none;

    width: 100%;
`);
export const MenuListItem = ({ className, ...props }) => (_jsx(StyledListItem, { className: clsx('MenuListItem-root', className), ...props }));
